'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.normalizePath = normalizePath;
exports.dirty = dirty;
exports.default = markAsDirty;

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function normalizePath(originalPath) {
  var path = String(originalPath);
  return path.replace(/\[/g, '.').replace(/\]/g, '');
}

function dirty(value) {
  if ((0, _isArray2.default)(value)) {
    return [].concat(value);
  }

  if ((0, _isPlainObject2.default)(value)) {
    return (0, _extends3.default)({}, value);
  }

  return value;
}

function markAsDirty(value, originalPath, updateCallback) {
  var start = dirty(value);
  var path = normalizePath(originalPath);
  var parts = path.split('.');

  var current = start;
  var before = void 0;

  parts.forEach(function (key) {
    current[key] = dirty(current[key]);

    before = current;
    current = current[key];
  });

  if (updateCallback) {
    var newValue = updateCallback(current);

    if (before !== undefined && parts.length) {
      var lastKey = parts[parts.length - 1];
      before[lastKey] = newValue;
    }
  }

  return start;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/utils/markAsDirty.js
 ** module id = 615
 ** module chunks = 0
 **/